export default __webpack_public_path__ + "static/media/IMG12.cb9799fa.jpg";